<template>
  <div>
    <section class="container quiz" v-if="atStart">
      <div v-html="ingress" class="ingress-text"></div>
      <button class="button btn-blue" v-on:click="atStart = false">
        {{ $t("general.aloita", currentLocale).toUpperCase() }}
      </button>
    </section>

    <section class="container quiz" v-if="!quizDone && !atStart">
      <div v-html="ingress" class="ingress-text" v-if="isCase"></div>
      <p :class="isCase ? 'mt-4 question' : 'mt-4 question text-center'">
        {{ currentQuestionText }}
      </p>
      <div class="my-4 answers">
        <div v-if="currentQuestionType === 'kaksivalinta'" class="pt-4 pb-4">
          <a v-on:click="answerYesNo(0)" :class="answerYesNoClass(0)">{{
            $t("general.oikein", currentLocale)
          }}</a>
          <a v-on:click="answerYesNo(1)" :class="answerYesNoClass(1)">{{
            $t("general.vaarin", currentLocale)
          }}</a>
        </div>

        <div
          v-if="currentQuestionType === 'monivalinta'"
          v-for="(option, index) in currentOptions"
          v-bind:key="option.vataus"
          :class="answerOptionClass(option, index)"
          v-on:click="answer(option, index)"
        >
          <div class="quiz-ball">{{ answerLabels[index] }}</div>
          <p>{{ option.vataus }}</p>
        </div>

        <div v-show="currentAnswer >= 0" class="feeback-container">
          <img
            src="../../assets/images/answer_right.png"
            v-if="currentResult"
            class="answer-icon"
          />
          <img
            src="../../assets/images/answer_wrong.png"
            v-if="!currentResult"
            class="answer-icon"
          />
          <h1 class="feedback">{{ feedbackHeading }}</h1>
          <p class="feedback text-center">{{ currentQuestionFeedback }}</p>
        </div>
      </div>

      <div class="mt-5 mb-5 text-center" v-show="nextEnabled">
        <button v-on:click="nextQuestion()" class="button btn-blue">
          {{ $t("general.seuraava", currentLocale).toUpperCase() }}
        </button>
        <p class="text-center">
          {{ $t("general.pisteesi", currentLocale) }} {{ score }}/{{
            requiredScore
          }}
        </p>
      </div>
    </section>

    <section class="container quiz" v-if="quizDone">
      <div class="results text-center">
        <!-- <h1 class="mt-5">Tuloksesi</h1> -->
        <h1 class="m-4">{{ score }}/{{ requiredScore }}</h1>
        <p class="text-center">{{ $t("general.hienoa", currentLocale) }}</p>
        <button class="button btn-blue" v-on:click="completed()">
          {{ $t("general.jatkat", currentLocale).toUpperCase() }}
        </button>
      </div>
    </section>
  </div>
</template>
<script>
export default {
  data: function () {
    return {
      atStart: true,
      questions: [],
      currentQuestion: 0,
      currentQuestionType: "",
      currentQuestionText: "",
      currentQuestionFeedback: "",
      currentQuestionIsTrue: false,
      currentOptions: [],
      feedbackHeading: "",
      answerLabels: ["A", "B", "C", "D", "E", "F"],
      currentAnswer: -1,
      currentResult: false,
      score: 0,
      total: 0,
      requiredScore: 10,
      nextEnabled: false,
      quizDone: false,
    };
  },
  props: {
    quizdata: null,
    ingress: "",
    isCase: false,
    minScore: null,
  },
  created: function () {
    if (this.quizdata) {
      this.resetQuiz();
    }
  },
  computed: {
    currentLocale() {
      return this.$route.params.locale;
    },
  },
  methods: {
    resetQuiz: function () {
      console.log("is case: " + this.isCase);

      this.questions = this.quizdata.slice(0);
      this.quizDone = false;
      this.currentQuestion = 0;
      this.currentAnswer = -1;
      this.score = 0;

      if (this.minScore !== undefined) {
        this.requiredScore = this.minScore;
      }
      if (this.isCase !== undefined && this.isCase) {
        this.requiredScore = this.questions.length;
      } else {
        this.questions = this.suffleQestions(this.questions);
      }

      this.setQuestion();
    },
    setQuestion: function () {
      if (this.questions) {
        this.currentQuestionType =
          this.questions[this.currentQuestion].acf_fc_layout;
        this.currentQuestionText = this.questions[this.currentQuestion].kysymys;
        this.currentQuestionFeedback =
          this.questions[this.currentQuestion].palaute;
        this.currentOptions = this.questions[this.currentQuestion].vaihtoehdot;
        if (this.currentQuestionType == "kaksivalinta") {
          this.currentQuestionIsTrue =
            this.questions[this.currentQuestion].tosi;
        }
        this.total = this.questions.length;
      }
    },
    answer: function (option, index) {
      if (this.currentAnswer < 0) {
        this.currentResult = option.oikein;
        if (option.oikein) {
          this.feedbackHeading =
            this.$t("general.vastauson", this.currentLocale) +
            " " +
            this.$t("general.oikein", this.currentLocale) +
            "!";
          this.score++;
        } else {
          this.feedbackHeading =
            this.$t("general.vastauson", this.currentLocale) +
            " " +
            this.$t("general.vaarin", this.currentLocale) +
            ".";
        }
        if (option.palaute) {
          this.currentQuestionFeedback = option.palaute;
        }
        this.currentAnswer = index;
        this.nextEnabled = true;
      }
    },
    answerYesNo: function (index) {
      if (this.currentAnswer < 0) {
        this.currentAnswer = index;
        this.currentResult =
          (this.currentQuestionIsTrue && index == 0) ||
          (!this.currentQuestionIsTrue && index == 1);
        if (this.currentResult) {
          this.feedbackHeading =
            this.$t("general.vastauson", this.currentLocale) +
            " " +
            this.$t("general.oikein", this.currentLocale) +
            "!";
          this.score++;
        } else {
          this.feedbackHeading =
            this.$t("general.vastauson", this.currentLocale) +
            " " +
            this.$t("general.vaarin", this.currentLocale) +
            ".";
        }
        this.nextEnabled = true;
      }
    },
    answerOptionClass: function (option, index) {
      if (this.currentAnswer == index) {
        if (this.currentResult) {
          return "answer selected-right";
        }
        return "answer selected-wrong";
      } else if (
        this.currentAnswer >= 0 &&
        option.oikein &&
        this.isCase !== true
      ) {
        return "answer selected-right";
      }
      return "answer";
    },
    answerYesNoClass: function (index) {
      if (this.currentAnswer == index) {
        if (this.currentResult) {
          return "button answerYesNo selected-right";
        }
        return "button answerYesNo selected-wrong";
      }
      return "button answerYesNo";
    },
    nextQuestion: function () {
      this.currentAnswer = -1;
      this.nextEnabled = false;

      window.scroll({ top: 600, left: 0, behavior: "smooth" });

      if (this.score >= this.requiredScore) {
        this.quizDone = true;
      } else {
        if (this.currentResult) {
          // remove question if answer was correct
          this.questions.splice(this.currentQuestion, 1);
        }
        if (this.currentQuestion < this.questions.length - 1) {
          this.currentQuestion++;
        } else {
          if (this.isCase !== true) {
            this.questions = this.suffleQestions(this.questions);
          }
          this.currentQuestion = 0;
        }
        this.setQuestion();
      }
    },
    suffleQestions: function shuffle(arr) {
      var ctr = arr.length,
        temp,
        index;
      while (ctr > 0) {
        index = Math.floor(Math.random() * ctr);
        ctr--;
        temp = arr[ctr];
        arr[ctr] = arr[index];
        arr[index] = temp;
      }
      return arr;
    },
    completed: function () {
      if (this.isCase) {
        this.$emit("casecompleted");
      } else {
        this.$emit("completed"); // send unlock event
      }
    },
  },
};
</script>
<style scoped lang="scss">
.quiz {
  max-width: 720px;
  margin: 0 auto;
  .answers {
    .answer {
      display: flex;
      align-items: center;
      justify-content: center;

      p {
        width: 75%;
        margin: 1em;
      }

      text-align: left;
      background: #c1e7f4;
      padding: 1rem;
      border-radius: 0.5rem;
      margin-bottom: 1em;

      .quiz-ball {
        font-size: 24px;
        text-align: center;
        color: #059df3;
        font-weight: bold;
        background: white;
        padding: 2px 0 0 0;
        width: 40px;
        height: 40px;
        display: inline-block;
        border-radius: 50%;
        -webkit-box-shadow: 0 3px rgba(110, 110, 110, 0.35);
        box-shadow: 0 3px rgba(110, 110, 110, 0.35);
      }
      &:hover,
      &:focus,
      &:active {
        background: #87cbe2;
        cursor: pointer;
      }
    }
    .selected {
      background: #87cbe2;
    }
    .selected-right {
      p {
        color: #fff;
      }
      background: #8cc63f;
      &:hover,
      &:focus,
      &:active {
        background: #8cc63f;
        cursor: default;
      }
      cursor: default;
    }
    .selected-wrong {
      p {
        color: #fff;
      }
      background: #ef5050;
      &:hover,
      &:focus,
      &:active {
        background: #ef5050;
        cursor: default;
      }
      cursor: default;
    }
  }
}

.answerYesNo {
  background: #c1e7f4;
  text-transform: uppercase;
  margin: 1em;
  @media (max-width: 768px) {
    display: block;
    padding: 1rem;
  }
}

.feeback-container {
  text-align: center;
  img {
    margin: 1em 0;
  }
}
.answer-icon {
  width: 100px;
}

.question {
  font-weight: 700;
}
</style>



// WEBPACK FOOTER //
// src/views/components/Quiz.vue